export const containerStyles =
   'w-full flex flex-row items-center ml-auto gap-x-[12px]'

export const profilePicImageStyles = 'w-[44px] h-[44px]'

export const queryContainerStyles =
   'relative px-[12px] py-[12px] border rounded-2xl max-w-full transition-colors duration-300ms flex-1'

export const querySubContainerStyles = 'flex flex-col gap-y-[4px]'

export const queryHeaderStyles =
   ' gap-x-[8px] relative px-[12px] py-[8px] border rounded-[12px] max-w-full transition-colors duration-300ms flex-1'

export const nameTextStyles = 'text-sm-medium'

export const dotStyles = 'w-[4px] h-[4px] rounded-full'

export const timeTextStyles = 'text-sm-medium'

export const userSearchQueryTextStyles =
   'text-sm-medium min-h-[24px]  max-h-[calc(100px_-_40px)] resize-none scrollbar'

export const textAreaContainerStyles =
   'border-none shadow-none ring-0 pl-0 flex-1'

export const userSearchQueryContainerStyles =
   'flex flex-col gap-y-[16px] flex-1'

export const buttonsContainerStyles =
   'self-end flex flex-row items-center gap-x-[8px]'

export const editButtonStyles = '!absolute -bottom-[16px] right-4'

export const editButtonTextStyles = 'text-sm-semibold'
